const BREAKPOINTS = {
    _0: '0px',
    _360: '360px',
    _560: '560px',
    _768: '768px',
    _970: '970px',
    _1024: '1024px',
    _1440: '1440px',
};
export default BREAKPOINTS;
export const getForEveryBreakpoint = (callback) => (Object.assign({}, Object.values(BREAKPOINTS).reduce((acc, breakpoint) => (Object.assign(Object.assign({}, acc), callback(breakpoint))), {})));
